var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.001,
    height: 14.001,
    viewBox: "0 0 14.001 14.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4092",
    "data-name": "\\uADF8\\uB8F9 4092",
    transform: "translate(-240 -759)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 14.001,
    height: 14.001,
    transform: "translate(240 759)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Color",
    "data-name": " \\u21B3Color",
    d: "M7,14a7,7,0,1,1,7-7A7.008,7.008,0,0,1,7,14ZM7,1.4A5.6,5.6,0,1,0,12.6,7,5.607,5.607,0,0,0,7,1.4ZM5.6,10.5h0L2.1,7l.987-.987L5.6,8.519l4.613-4.613L11.2,4.9,5.6,10.5Z",
    transform: "translate(240 759)",
    fill: "#f55555"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckRed);
export default __webpack_public_path__ + "static/media/iconCheckRed.9795dc0ecde0e6f85d9e128ca7104014.svg";
export { ForwardRef as ReactComponent };